import { DomainCode } from "src/app/models/common/model";
import { ContainerSizeType } from "src/app/models/container_master_model/sizeType";

export interface IRequirementsModel {
    id?: string;
    quantity?: number;
    container_size_type?: string;
    condition?: string;
    leasing_period_days?: number;
    per_diem?: number;
    per_diem_currency?: string;
    csc_revalidation_required?: boolean;
    purpose?: string;
}

export interface IRequirementError {
    quantity: string[];
    container_size_type: string[];
    condition: string[];
    leasing_period_days: string[];
    per_diem: string[];
    per_diem_currency: string[];
    csc_revalidation_required: string[];
    purpose: string[];
}

export class RequirementError implements IRequirementError {
    quantity: string[];
    container_size_type: string[];
    condition: string[];
    leasing_period_days: string[];
    per_diem: string[];
    per_diem_currency: string[];
    csc_revalidation_required: string[];
    purpose: string[];

    constructor() {
        this.resetRequirementError();
    }

    resetRequirementError() {
        this.quantity = [];
        this.container_size_type = [];
        this.condition = [];
        this.leasing_period_days = [];
        this.per_diem = [];
        this.per_diem_currency = [];
        this.csc_revalidation_required = [];
        this.purpose = [];
    }

    is_oneway_requirement_valid(req) {
        this.resetRequirementError();

        if (req.quantity == null) {
            this.quantity = ['Quantity is required'];
        }
        if (req.container_size_type == null) {
            this.container_size_type = ['Select Container Type'];
        }
        if (req.condition == null) {
            this.condition = ['Select Container Condition'];
        }

        return this.quantity.length == 0 &&
            this.container_size_type.length == 0 &&
            this.condition.length == 0
    }

    is_trade_requirement_valid(req) {
        this.resetRequirementError();

        if (req.quantity == null) {
            this.quantity = ['Quantity is required'];
        }
        if (req.container_size_type == null) {
            this.container_size_type = ['Select Container Type'];
        }
        if (req.condition == null) {
            this.condition = ['Select Container Condition'];
        }
        if (req.purpose == null) {
            this.purpose = ['Purpose is required'];
        }

        return this.quantity.length == 0 &&
            this.container_size_type.length == 0 &&
            this.condition.length == 0 &&
            this.purpose.length == 0
    }

    is_lease_requirement_valid(req) {
        this.resetRequirementError();

        if (req.quantity == null) {
            this.quantity = ['Quantity is required'];
        }
        if (req.container_size_type == null) {
            this.container_size_type = ['Select Container Type'];
        }
        if (req.condition == null) {
            this.condition = ['Select Container Condition'];
        }
        if (req.leasing_period_days == null) {
            this.leasing_period_days = ['Leasing Period is required'];
        }

        return this.quantity.length == 0 &&
            this.container_size_type.length == 0 &&
            this.condition.length == 0 &&
            this.leasing_period_days.length == 0
    }
}

export class RequirementsModel {
    id?: any;
    quantity?: number;
    container_size_type?: ContainerSizeType;
    condition?: DomainCode;
    leasing_period_days?: number;
    per_diem?: number;
    per_diem_currency?: string;
    csc_revalidation_required?: boolean;
    purpose?: string;

    constructor(data = null) {
        this.id = data ? data.id : null;
        this.quantity = data ? data.quantity : null;
        this.container_size_type = data ? data.container_size_type : null;
        this.condition = data ? data.condition : null;
        this.leasing_period_days = data ? data.leasing_period_days : 0;
        this.per_diem = data ? data.per_diem : null;
        this.per_diem_currency = data ? data.per_diem_currency : 'USD';
        this.csc_revalidation_required = data ? data.csc_revalidation_required : false;
        this.purpose = data ? data.purpose : 'export';
    }

    getOneWayRequirementPayload() {
        return {
            id: this.id,
            quantity: this.quantity,
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
        }
    }

    getTradeRequirementPayload() {
        return {
            id: this.id,
            quantity: this.quantity,
            csc_revalidation_required: this.csc_revalidation_required,
            purpose: this.purpose,
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
        }
    }

    getLeaseRequirementPayload() {
        return {
            id: this.id,
            quantity: this.quantity,
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
            leasing_period_days: this.leasing_period_days,
            per_diem: this.per_diem,
            per_diem_currency: this.per_diem_currency,
        }
    }

    getEmptytRepoPayload() {
        return {
            id: this.id,
            quantity: this.quantity,
            container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
            condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
        }
    }
}
export class ContactsModel {
    contact_name?: string;
    contact_email?: string;
    contact_number?: string;
    profile_role?: string;

    constructor(data = null) {
        this.contact_name = data ? data.contact_full_name : '';
        this.contact_email = data ? data.contact_email : '';
        this.contact_number = data ? data.contact_number : '';
        this.profile_role = data ? data.designation : '';
    }
}
